import React from "react";
import { Box } from "@mui/material";
import Header from "./Header";
import Hero from "./Hero";
import Features from "./Features";
import CallToAction from "./CallToAction";
import Footer from "./Footer";

export default function Home() {
  return (
    <Box sx={{ minHeight: "100vh", background: "var(--surface-page)" }}>
      <Header />
      <Hero />
      <Features />
      <CallToAction />
      <Footer />
    </Box>
  );
}
